<template>
  <Teleport to="body">
    <UIBaseTransition name="fade">
      <Component
        v-if="UIStore.getDynamicPopup.component"
        :is="UIStore.getDynamicPopup.component"
        v-bind="UIStore.getDynamicPopup.data || {}"
        v-model="UIStore.getDynamicPopup.value"
        v-on="UIStore.getDynamicPopup.events || {}"
        @update:model-value="UIStore.cleanPopup"
      />
    </UIBaseTransition>
  </Teleport>
</template>

<script setup lang="ts">
const UIStore = useUIStore()
</script>

<style scoped></style>
